export default "__VITE_PUBLIC_ASSET__b0aed7e0__"